import { render, staticRenderFns } from "./Bin.vue?vue&type=template&id=1c1e8df2&"
import script from "./Bin.vue?vue&type=script&lang=js&"
export * from "./Bin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports